import { render, staticRenderFns } from "./DataCuesFooter.vue?vue&type=template&id=b49ab022"
import script from "./DataCuesFooter.vue?vue&type=script&lang=js"
export * from "./DataCuesFooter.vue?vue&type=script&lang=js"
import style0 from "./DataCuesFooter.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports